export const CSAT_MODULE_KEY = 'shared/csat';

export interface IState {
  lastAnswerDate: string | undefined | null,
  questionsList: IQuestion[] | null
}

export interface SatisfactionQuestionResponseDto {
  satisfactionQuestionsList: IQuestion[]
}

export interface LastAnswerDateResponseDto {
  lastAnswerDate: string
}

export interface IQuestion {
  id: number,
  text: string
}

export interface IUserAnswer {
  satisfactionQuestionId: number | undefined,
  rating: number,
  comment: string
}

export interface ISatisfactionAnswersList {
  satisfactionAnswersList: IUserAnswer[]
}


